import Vue                          from 'vue'
import App                          from './App.vue'
import router                       from './router'
import vuetify                      from '@/plugins/vuetify'
import { CONFIG as MIBConfig }      from './config'

Vue.config.productionTip = false
Vue.prototype.$conf = MIBConfig;

new Vue({
	vuetify,
	data: () => ({
		drawer: null
	}),
	router,
	render: h => h(App)
}).$mount('#app')
